import React, {
  PureComponent,
  ReactElement,
  ReactNode,
  ReactText,
} from "react";
import { animated, Spring, SpringProps } from "react-spring";
import styled from "styled-components";

const ToggleSlideWrapper = styled.div`
  flex-grow: 1;
`;

export interface IProps {
  children: ReactNode[] | ReactNode;
  duration?: number;
  immediate?: boolean;
  onRest?: () => void;
  open: boolean;
}

type IDefaultProps = Required<Pick<IProps, "duration" | "immediate">>;

class ToggleSlide extends PureComponent<IProps, {}, IDefaultProps> {
  public static defaultProps: IDefaultProps = {
    duration: 500,
    immediate: false,
  };

  public render(): ReactNode {
    const { children, immediate, onRest, open, duration } = this.props;

    return (
      <ToggleSlideWrapper>
        <Spring
          native
          config={{ duration }}
          from={{ height: open ? 0 : "auto" }}
          to={{ height: open ? "auto" : 0 }}
          immediate={immediate}
          onRest={onRest}
        >
          {(props: { height: ReactText }): ReactElement<SpringProps> => (
            <animated.div
              className="item"
              style={{ ...props, overflow: "hidden", flexGrow: 1 }}
            >
              {children}
            </animated.div>
          )}
        </Spring>
      </ToggleSlideWrapper>
    );
  }
}

export default ToggleSlide;
